export default {"src":"/_next/static/media/payment-usdc-icon.2031ac80.svg","height":20,"width":28};